<!-- Botón flotante (FAB) del chatbot — Req 5.2, 5.3 -->
<div class="chatbot-fab-container">

  <!-- Panel del chatbot (visible cuando isPanelOpen es true) -->
  <app-chatbot-panel *ngIf="isPanelOpen"></app-chatbot-panel>

  <!-- Botón flotante -->
  <button
    class="chatbot-fab"
    (click)="togglePanel()"
    [attr.aria-label]="isPanelOpen ? 'Cerrar asistente' : 'Abrir asistente'"
    [attr.title]="isPanelOpen ? 'Cerrar asistente' : 'Abrir asistente'"
    [class.chatbot-fab--open]="isPanelOpen"
    type="button"
  >
    <i
      class="bi"
      [class.bi-chat-dots-fill]="!isPanelOpen"
      [class.bi-x-lg]="isPanelOpen"
    ></i>
  </button>

</div>
